// extracted by mini-css-extract-plugin
export var blue = "_1j-f";
export var brand = "_1j-b";
export var darkGrey = "_1j-e";
export var disabled = "_1j-4";
export var disabledSubtle = "_1j-5";
export var error = "_1j-6";
export var green = "_1j-g";
export var grey = "_1j-d";
export var icon = "_1j-0";
export var inherit = "_1j-a";
export var lightGrey = "_1j-c";
export var orange = "_1j-i";
export var pink = "_1j-k";
export var primary = "_1j-1";
export var purple = "_1j-l";
export var red = "_1j-j";
export var secondary = "_1j-2";
export var success = "_1j-9";
export var tertiary = "_1j-3";
export var warning = "_1j-7";
export var warningSecondary = "_1j-8";
export var white = "_1j-m";
export var yellow = "_1j-h";